import { PRIMARY_BLUE, WHITE } from '~/Constants/Colors.constants';
import { CONTAINER_BOX_SHADOW } from '~/Constants/CSS.constants';
import { makeStyles } from '~/UIKit/Style';
import { HEADER_HEIGHT_MOBILE } from '~/Constants/UI.constants';

export const useStyles = makeStyles((theme) => ({
  CalendarListContainer: {
    height: 'inherit',
    backgroundColor: WHITE,
    [theme.breakpoints.up('md')]: {
      width: 220,
    },
  },
  dashboardContainer: {
    display: 'flex',
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: `calc(100vh - ${HEADER_HEIGHT_MOBILE}px - 3px)`,
    [theme.breakpoints.up('md')]: {
      boxShadow: CONTAINER_BOX_SHADOW,
      height: '100%',
      minHeight: 600,
    },
  },
  eventListContainer: {
    background: WHITE,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'auto',
  },
  eventCarouselContainer: {
    flexGrow: 1,
  },
  sectionHeaderText: {
    fontWeight: 'bold',
    color: PRIMARY_BLUE,
    textAlign: 'center',
  },
  sectionHeader: {
    backgroundColor: WHITE,
  },
  createNewEvent: {
    cursor: 'pointer',
  },
  nextWeekButton: {
    margin: '15px 0',
  },
  loading: {
    display: 'flex',
    placeContent: 'center',
    placeItems: 'center',
    marginTop: 120,
  },
  noEvents: {
    padding: '22px 15px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    '& > p > a': {
      color: PRIMARY_BLUE,
    },
    '& svg': {
      width: 100,
      height: 'auto',
    },
  },
  noEventsLabel: {
    marginBottom: 10,
  },
  nextEventButton: {
    minWidth: 124,
    fontSize: 12,
    marginTop: 15,
  },
}));
